import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { getForm, storeFormsResponseIntoDB } from "../../apis/forms";
import RenderContainer from "../common/components/RenderContainer";
var Forms = function () {
    var config = useMemo(function () { return ({
        fetchForm: getForm,
        storeResponse: function (formId, storeData, token) {
            return storeFormsResponseIntoDB(formId, storeData, token);
        },
        requireAuth: true,
        requireServiceSlug: false,
        logPrefix: "F",
    }); }, []);
    return _jsx(RenderContainer, { config: config });
};
export default Forms;
